export const isEmpty = <T>(v: T) => {
	if (v === null || v === undefined) return true
	return v === ""
}

export const isNotEmpty = <T>(v: T): v is NonNullable<T> => v !== null && v !== undefined && v !== ""
